import { PLACE_NORMALTRADE_CLEAR_DATA, PLACE_NORMALTRADE_DATA, PLACE_NORMALTRADE_ERROR_DATA, PLACE_NORMALTRADE_HIDE_ERROR_DATA, PLACE_NORMALTRADE_START_LOADER, PLACE_NORMALTRADE_STOP_LOADER, } from "../interface/IPlaceNormalTrade";
const initState = {
    data: {
        message: "",
        orderID: "",
        success: false,
    },
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const placeNormalTrade = (state = initState, action) => {
    switch (action.type) {
        case PLACE_NORMALTRADE_DATA: {
            return Object.assign(Object.assign({}, state), { data: action.payload.placeNormalTrade });
        }
        case PLACE_NORMALTRADE_CLEAR_DATA:
            return Object.assign(Object.assign({}, state), { data: initState.data });
        case PLACE_NORMALTRADE_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case PLACE_NORMALTRADE_HIDE_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case PLACE_NORMALTRADE_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case PLACE_NORMALTRADE_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default placeNormalTrade;
